import { useCallback } from 'react'
import debounce from 'lodash/debounce'

// eslint-disable-next-line react-hooks/exhaustive-deps
const useDebounce = (fn, timeout = 400) => useCallback(debounce(fn, timeout), [])

export default useDebounce
